module.exports = __webpack_public_path__ + "static/img/game_jf_0324.42739a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_grande/game_jf_0324.png
// module id = eGyK
// module chunks = 1